import React from 'react';

import { AjaxListingContext, AjaxListingNextButton } from '$partials/base';
import { ArticleListingItem } from '$partials/items';
import { Footer, Header } from '$partials/global';
import { useAjaxListing } from '$hooks/ajax-listing';
import ArticleSplitColumns from '$partials/modules/blocks/article-split-columns';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').TagDetailPage}
 */
const TagDetailPage = (props) => {
    const page = props.data.page;

    const listing = useAjaxListing({
        infinite: false,
        items: page?.items?.edges,
        page: page?.items?.pageInfo?.page,
        path: `/api/v1/listings${page?.url ?? ''}`,
        totalItems: page?.items?.total,
        totalPages: page?.items?.pageInfo?.totalPages,
    });

    return (
        <>
            <Header
                {...props?.data?.header}
                pageType={page.__typename} />

            <AjaxListingContext.Provider value={listing}>
                <main id='main-content'>
                    <div className='layout-container layout-site-outer-padding pb-8 md:pb-16'>
                        <div className='col-wrapper-breakout bg-surface-panel-red py-24 rounded-lg flex flex-col gap-y-8 md:gap-y-16'>
                            {/* Heading */}
                            <section className='flex flex-col pb-8 md:pb-16 col-padding'>
                                <h1 className='type-style-sans-display'>
                                    {page.title}
                                </h1>
                            </section>
                            <AjaxListingContext.Consumer>
                                {(listingState) => {
                                    if (!listingState.items.length) {
                                        return (
                                            <section className='col-padding'>
                                                <p className='type-style-sans-body'>
                                                    No articles
                                                    <span className='sr-only'>
                                                        Found
                                                    </span>
                                                </p>
                                            </section>
                                        );
                                    }
                                    const heroArticle = listingState.items[0]?.node;
                                    const featuredArticles = listingState.items?.slice(1, 5);
                                    const rest = listingState.items?.slice(5);
                                    return (
                                        <>
                                            {/* Hero article */}
                                            <section className='col-padding flex flex-col gap-y-8 md:gap-y-16'>
                                                <h2 className='sr-only'>
                                                    Articles
                                                </h2>

                                                <ArticleListingItem
                                                    orientation='wide'
                                                    {...heroArticle}/>

                                                {/* Split column articles */}
                                                {featuredArticles.length > 0 && (
                                                    <ArticleSplitColumns items={featuredArticles.map(article => article.node)}/>
                                                )}

                                                {rest.length > 0 && (
                                                    <div className='gap-8 md:gap-16 grid sm:grid-cols-2 md:grid-cols-3'>
                                                        {rest.map((itm, idx) => {
                                                            return (
                                                                <article
                                                                    aria-posinset={idx + 1}
                                                                    aria-setsize={listing.items.length}
                                                                    className=''
                                                                    key={itm.node.id + '-' + idx}>
                                                                    <ArticleListingItem {...itm.node} />
                                                                </article>
                                                            );
                                                        })}
                                                    </div>
                                                )}

                                                {listing?.page !== listing?.totalPages && (
                                                    <AjaxListingNextButton
                                                        aria-label='Load more articles'
                                                        className='button-outcome mt-40 self-start'>
                                                        <span>Load more...</span>
                                                    </AjaxListingNextButton>
                                                )}
                                            </section>
                                        </>
                                    );}}
                            </AjaxListingContext.Consumer>


                        </div>
                    </div>
                </main>
            </AjaxListingContext.Provider>

            <Footer
                {...props?.data?.footer}
                pageType={page.__typename}/>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default TagDetailPage;
